import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

// Visible, category-level FAQ block. Pairs with the FAQPage JSON-LD emitted on
// the category page so Google can surface these as rich answers in search.
export default function CategoryFaq({ title, faqs }) {
  return (
    <section className="border-t border-hair py-8" data-testid="category-faq">
      <h2 className="font-serif text-2xl font-medium text-ink">
        Frequently asked questions about {title} support
      </h2>
      <Accordion type="single" collapsible className="mt-5 border-t border-hair">
        {faqs.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            className="border-b border-hair"
            data-testid={`category-faq-${i}`}
          >
            <AccordionTrigger className="gap-4 py-5 text-left hover:no-underline [&[data-state=open]>svg]:text-accent">
              <span className="font-serif text-lg font-medium text-ink">{f.q}</span>
            </AccordionTrigger>
            <AccordionContent>
              <p className="max-w-2xl text-sm leading-relaxed text-muted">{f.a}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
